module.exports = __webpack_public_path__ + "img/veselo-sky-mob.6df6daa4.png";